<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card v-if="!isOnCreate" v-can="'view-sundry-orders'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Payment Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['payment-status']"
                         :options="['GRNI', 'Pre Invoice', 'Paid']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Order Items Status</label>
              <v-select  :clearable="true" placeholder="" multiple v-model="filters['item-status']" label="name"
                         :options="sundry_item_order_item_statuses" :reduce="option => option.name"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['from']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['from']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['to']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['to']"
                placeholder="Choose Date"
              />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card v-if="!isOnCreate" title="SUNDRY ITEM ORDERS">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'sundry-order-sheet'" :filters="filters"/>
              <vs-button v-can="'create-edit-sundry-orders'" @click="isOnCreate = true" class="mr-4 mb-4" color="primary" type="filled">Create new order</vs-button>
            </div>
          </template>
          <div v-can="'view-sundry-orders'" slot="no-body" class="mt-4">
            <vs-table
              id="sundry-item-orders-list"
              :max-orders="(meta.per_page) ? meta.per_page : 10"
              :data="orders"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" sort-key="created_at">DATE/TIME</vs-th>
                <vs-th width="10%" sort-key="sundry_order_code">ORDER CODE</vs-th>
                <vs-th width="15%" sort-key="sundry_supplier">SUNDRY SUPPLIER</vs-th>
                <vs-th width="10%">ORDERED BY</vs-th>
                <vs-th width="5%">CURRENCY</vs-th>
                <vs-th width="5%">ORDER VALUE</vs-th>
                <vs-th width="10%">PAYMENT STATUS</vs-th>
                <vs-th width="5%" v-if="$can('create-edit-sage-purchase-order')">SAGE ID</vs-th>
                <vs-th width="20%">STATUS</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickOrderDetails(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td>
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td class="font-semibold text-primary" :data="data[indextr].sundry_order_code">
                    {{ data[indextr].sundry_order_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_supplier">
                    <HyperLink :id="data[indextr].sundry_supplier_id" type="sundry_supplier">{{ data[indextr].sundry_supplier}}</HyperLink>
                  </vs-td>

                  <vs-td :data="data[indextr].staff">
                    {{ data[indextr].staff}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_supplier_currency">
                    {{ data[indextr].sundry_supplier_currency}}
                  </vs-td>

                  <vs-td class="flex justify-end mr-4">
                    {{ totalCalculator(data[indextr].sundry_items)}}
                  </vs-td>

                  <vs-td>
                    {{ paymentStatusGenerator(data[indextr].sundry_items)  }}
                  </vs-td>

                  <vs-td v-if="$can('create-edit-sage-purchase-order')">
                    <span v-if="data[indextr].sage_purchase_order_id || data[indextr].sage_order_number">
                      {{ data[indextr].sage_order_number ? data[indextr].sage_order_number : data[indextr].sage_purchase_order_id}}
                    </span>
                    <span class="text-danger cursor-pointer" v-else>
                      <vx-tooltip class="mr-2" text="Sync order to sage" position="left">
                        <vs-button @click.stop="onClickSageSyncOrder(data[indextr])"
                                 size="small" color="danger" type="filled" icon-pack="feather" icon="icon-refresh-cw"/>
                      </vx-tooltip>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip v-if="data[indextr].sundry_items.length === 1"
                             class="text-center" transparent :color="sundryOrderColorFactory(tr.sundry_items[0].item_status)">
                      {{ data[indextr].sundry_items[0].item_status || 'Submitted'}}
                    </vs-chip>
                    <vs-chip v-else>
                      multiple items
                    </vs-chip>
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip class="ml-1" text="View" position="left">
                        <vs-button @click.stop="onClickOrderDetails(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-1" text="Edit" position="left">
                        <vs-button @click.stop="onClickUpdateDetails(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxorders="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-orders="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-orders="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
        <sundry-item-price-list v-on:back="refreshAndBack" v-if="isOnCreate"/>
      </div>
    </div>
    <create-sundry-supplier-document-pop-up ref="createSundrySupplierDocumentPopUp"/>
    <update-sundry-supplier-document-pop-up ref="updateSundrySupplierDocumentPopUp" />
    <partial-items-status-change-sundry-orders-pop-up ref="partialItemsStatusChangeSundryOrdersPopUp"/>
    <update-sundry-item-order-details-popup ref="UpdateSundryItemOrderDetailsPopup" />

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import CreateSundrySupplierDocumentPopUp from '@/components/popups/sundry-suppliers/CreateSundrySupplierDocumentPopUp'
  import UpdateSundrySupplierDocumentPopUp from '@/components/popups/sundry-suppliers/UpdateSundrySupplierDocumentPopUp'
  import PartialItemsStatusChangeSundryOrdersPopUp from "@/components/popups/sundry-suppliers/sundry-item-orders/PartialItemsStatusChangeSundryOrdersPopUp";
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import SundryOrderItemsTable from "./SundryOrderItemsTable";
  import {defaultPagination, perPageList} from "@/constants/config";
  import { sundry_item_order_item_statuses } from "@/constants/statuses"
  import SundryItemPriceList from "./SundryItemPriceList";
  import UpdateSundryItemOrderDetailsPopup
    from "@/components/popups/sundry-suppliers/sundry-item-orders/UpdateSundryItemOrderDetailsPopup";
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'

  const SundrySuppliersRepository = RepositoryFactory.get('sundry')
  const SageRepository = RepositoryFactory.get('sage')
  export default {
    name: 'AllUsersList',
    data () {
      return {
        orders: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        id: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        isOnCreate: false,
        sundry_item_order_item_statuses: sundry_item_order_item_statuses
      }
    },
    components: {
      UpdateSundryItemOrderDetailsPopup,
      'v-select': vSelect,
      CreateSundrySupplierDocumentPopUp,
      UpdateSundrySupplierDocumentPopUp,
      SundryOrderItemsTable,
      SundryItemPriceList,
      PartialItemsStatusChangeSundryOrdersPopUp,
      flatPickr
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.id = this.$route.params.id
      this.setFilterId('sundry_item_orders_list_filters',['search','payment-status','item-status','from','to'])
    },
    methods: {
      async refreshData () {
        this.fetchSundryItemOrders()
      },
      async refreshAndBack() {
        this.isOnCreate = false
        await this.fetchSundryItemOrders()
      },
      async onClickOrderDetails (id) {
        this.$router.push({path: `/pages/sundry-items/orders/${id}`})
      },
      async fetchSundryItemOrders() {
        await this.$vs.loading()
        const {data} = await SundrySuppliersRepository.getListOfSundryItemOrders(this.page, this.filterQuery, this.perPage, this.sort)
        this.orders =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      async onClickUpdateSundrySupplierDocument (data) {
        await this.$refs.updateSundrySupplierDocumentPopUp.openPopup(data)
      },
      async onClickCreateSundrySupplierDocument () {
        await this.$refs.createSundrySupplierDocumentPopUp.openPopup(this.id)
      },
      async onClickUpdateDetails(id) {
        await this.$refs.UpdateSundryItemOrderDetailsPopup.openPopup(id)
      },
      async onClickSageSyncOrder(data){
        let payload = {
          order_id: data.id,
          order_type:'sundry_item',
          supplier_id : data.sundry_supplier_sage_id,
          document_no: data.sundry_order_code,
          supplier_document_no: data.sundry_order_code,
          lines: data.sundry_items.map((n) => {
            return {
              line_type:1,
              use_description:true,
              description: n.sundry_product_name || n.sundry_item_code,
              line_quantity: n.quantity+ '',
              allocated_quantity: n.quantity+ '',
              unit_buying_price: n.price + ''
            }
          })
        }
        if ( data.sundry_supplier_sage_id) {
          this.$vs.loading()
          try {
            await SageRepository.createRmOrder({orders: [payload]})
            await this.refreshData()
          } catch (error) {
            this.convertAndNotifyError(error)
          }
          this.$vs.loading.close()
        }else {
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: 'This Supplier is not synchronised on Sage. You must do that before you can attempt to synchronise any Sundry order.',
            acceptText: 'Close'
          })
        }
      },


      async onClickStatusChangeConfirm (id, status, items) {
        if (['part_dispatched', 'part_received', 'part_return'].includes(status)) {
          await this.$refs.partialItemsStatusChangeSundryOrdersPopUp.openPopup(id, status, items)
        } else {
          this.$vs.dialog({
            type: 'confirm',
            color: 'primary',
            title: 'Confirm',
            text: 'Are you sure you want to make this change?',
            accept: this.onClickChangeSundryOrderStatus,
            parameters: [id, status]
          })
        }
      },
      async onClickChangeSundryOrderStatus(params) {
        this.$vs.loading()
        try {
          await SundrySuppliersRepository.changeSundryItemOrderStatus(params[0], params[1])
          this.showSuccessMessage('Sundry item order status updated')
          await this.fetchSundryItemOrders()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      totalCalculator(data) {
        const total =  data.reduce((acc, obj) => {return acc + Number(obj.price) * Number(obj.quantity)}, 0)
        return total.toFixed(2)
      },

      filterQueryUpdate (){
        this.fetchSundryItemOrders()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSundryItemOrders()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSundryItemOrders()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      sundryOrderColorFactory(status_name) {
        let selected_status = this.sundry_item_order_item_statuses.find((n) => n.name === status_name)
        return selected_status ?  selected_status.color : 'warning'
      },
      paymentStatusGenerator(items) {
        const firstItemStatus = items[0].payment_status;
        const allItemsHaveSameStatus = items.every(item => item.payment_status === firstItemStatus);
        return (items.length === 1 ) ? firstItemStatus : (allItemsHaveSameStatus ? firstItemStatus : 'Multiple Items');
      }
    },
    watch : {
      page(){
        this.fetchSundryItemOrders()
      },
      perPage() {
        this.fetchSundryItemOrders()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
